// extracted by mini-css-extract-plugin
export default {"portfolioProject":"PortfolioProject_portfolioProject__cQWm4"};